import { tectonFeatureOutletObservedAttrs, tectonFeatureOutlet } from './feature-outlet';
import { tectonTabbedOutletObservedAttrs, TectonTabbedOutlet } from './tabbed-outlet';
import { setupTectonElement } from 'q2-tecton-common/lib/outlets/tecton-outlet-base';
import { IMessageBus } from 'q2-tecton-common/lib/utility/message-bus';
import { ITranslationSetup } from '../t';

export default function setupQ2Outlets(
    messageBus: IMessageBus,
    moduleId: string,
    loc: ITranslationSetup['tFn'],
    resize: () => void
): void {
    setupTectonElement({
        messageBus,
        moduleId,
        props: tectonFeatureOutletObservedAttrs,
        tectonOutletAdaptor: tectonFeatureOutlet,
        resize
    })('tecton-outlet');

    setupTectonElement({
        messageBus,
        moduleId,
        props: tectonTabbedOutletObservedAttrs,
        tectonOutletAdaptor: TectonTabbedOutlet(loc),
        resize
    })('tecton-tabbed-outlet');
}
